export interface Size {
  id: string;
  key: string;
  description: string;
}
